import React from "react";
import oeiruty from '../media/hobspot-loader.webp';
import styles from '../preloader.module.css';


const Loader = ()=>{
    return(
    // <div style={{
    //     overflow:'hidden'
    // }}>
    //         <img 
    //     alt="loader"
    //     src={oeiruty}
    //     style={{
    //         width:'100vw',
    //         height  :'100vh',
    //         backgroundRepeat:'no-repeat',
    //     }}
    //     />
    // </div>
    <div className={styles.SpinningPreloader_comp}>
        
        <div className={styles.Loading}>
            <div className={styles.circle}></div>
        </div>

    </div>
    )
};

export default Loader;